import {
  slAccountColumnDefinition,
  slViewColumnDefinition,
  lifecycleMapColumnDefinition,
} from '../columnDefinitions';

export default [
  slAccountColumnDefinition,
  slViewColumnDefinition,
  lifecycleMapColumnDefinition,
];
